import { LOTTO_CONSTANTS } from '../constants';

const generateTicketId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `ticket-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

export const removeBetTicketUtil = (messages, messageIndex, ticketIndex) => {
  const message = messages[messageIndex];
  if (!message) return messages;
  if (message.type !== 'assistant') return messages;

  const component = message.a2ui?.components?.[0];
  if (component?.type !== 'bet_tickets') return messages;

  const tickets = component.props.bet_tickets || [];
  if (ticketIndex < 0 || ticketIndex >= tickets.length) return messages;

  const updatedTickets = tickets.filter((_, idx) => idx !== ticketIndex);

  if (updatedTickets.length === 0) {
    return messages.filter((_, idx) => idx !== messageIndex);
  }

  const updatedMessages = [...messages];
  updatedMessages[messageIndex] = {
    ...message,
    a2ui: {
      ...message.a2ui,
      components: [
        {
          ...component,
          props: { ...component.props, bet_tickets: updatedTickets },
        },
      ],
    },
  };
  return updatedMessages;
};

export const removeBetTicketById = (messages, messageId, ticketIndex) => {
  const messageIndex = messages.findIndex((m) => m.id === messageId);
  if (messageIndex === -1) return messages;
  return removeBetTicketUtil(messages, messageIndex, ticketIndex);
};

export const ensureTicketId = (ticket) =>
  ticket.ticket_id ? ticket : { ...ticket, ticket_id: generateTicketId() };

export const ensureTicketIds = (tickets) => tickets.map(ensureTicketId);

export const buildInitialSelectedNumbers = (
  mainGridNumbers,
  secondaryGridNumbers
) => {
  const hasNumbers = mainGridNumbers > 0 || secondaryGridNumbers > 0;
  if (!hasNumbers) return null;

  const selectedNumbers = [];
  for (let i = 0; i < mainGridNumbers; i++) {
    selectedNumbers.push({ type: 'NORMAL', value: NaN });
  }
  for (let i = 0; i < secondaryGridNumbers; i++) {
    selectedNumbers.push({ type: 'BONUS', value: NaN });
  }
  return selectedNumbers;
};

export const buildSelectedOutcomeData = (
  lotteryMetadata,
  categoryKey,
  categoryTitle,
  marketType,
  marketTitle,
  mainGridNumbers,
  secondaryGridNumbers,
  outcome
) => ({
  lotteryId: lotteryMetadata.lottery_id,
  lotteryName: lotteryMetadata.lottery_name,
  mainGridTotal: lotteryMetadata.main_grid_total,
  secondaryGridTotal: lotteryMetadata.secondary_grid_total,
  secondaryUnique: lotteryMetadata.secondary_unique,
  nextDraw: lotteryMetadata.next_draw,
  categoryKey,
  categoryTitle,
  marketType,
  marketTitle,
  mainGridNumbers,
  secondaryGridNumbers,
  outcome,
});

export const buildBetTicketFromSelectedOutcome = (data) => {
  const balls = buildInitialSelectedNumbers(
    data.mainGridNumbers,
    data.secondaryGridNumbers
  );
  const hasNumbers = balls !== null;

  return {
    ticket_id: generateTicketId(),
    draw_id: data.lotteryId,
    draw_date: data.nextDraw?.draw_date ?? 0,
    draw_number: data.nextDraw?.draw_number ?? '',
    lottery_name: data.lotteryName,
    market_category: data.categoryKey,
    market_title: data.marketTitle,
    market_type: data.marketType,
    outcome: data.outcome,
    potential_payout: 0,
    balls,
    stake: LOTTO_CONSTANTS.DEFAULT_STAKE,
    main_grid_total: data.mainGridTotal,
    secondary_grid_total: data.secondaryGridTotal,
    secondary_unique: data.secondaryUnique,
    initialEditMode: hasNumbers,
    repeat_for_draws: 1,
    change_odds_agreement: true,
    isModified: true,
  };
};
